/* Collection list page — "Load more" button / Infinite scroll
 * (section.settings.pagination_type in sections/collections.liquid).
 * Numbered pages stay in the DOM as a no-JS fallback; here we hide them and
 * fetch the next page's grid over the wire, appending cards in place.
 * Same approach as initCollectionPagination() in section-collection.js.
 */
function initCollectionsListPagination(section) {
  const mode = section.dataset.paginationType;
  if (mode !== 'load_more' && mode !== 'infinite') return;

  const grid = section.querySelector('[data-collections-grid]');
  if (!grid) return;

  const numberedNav = section.querySelector('[data-pagination-nav]');
  if (numberedNav) numberedNav.hidden = true;

  const trigger = section.querySelector('[data-infinite-trigger]');
  if (!trigger) return; // already on the last page

  const loadMoreBtn = trigger.querySelector('[data-load-more]');
  const spinner = trigger.querySelector('[data-infinite-spinner]');
  const statusEl = trigger.querySelector('[data-infinite-status]');

  let nextUrl = trigger.dataset.nextUrl || '';
  let loading = false;
  let observer = null;

  const usingObserver = mode === 'infinite' && 'IntersectionObserver' in window;
  if (usingObserver && loadMoreBtn) loadMoreBtn.hidden = true;

  function setBusy(state) {
    loading = state;
    if (spinner) spinner.hidden = !state;
    if (loadMoreBtn) loadMoreBtn.disabled = state;
  }

  function done() {
    if (observer) observer.disconnect();
    trigger.remove();
  }

  function loadNext() {
    if (loading || !nextUrl) return;
    setBusy(true);
    if (statusEl) statusEl.textContent = '';

    fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((res) => {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-collections-grid]');

        if (newGrid && newGrid.children.length) {
          const frag = document.createDocumentFragment();
          Array.from(newGrid.children).forEach((child) => frag.appendChild(child));
          grid.appendChild(frag);
        }

        const newTrigger = doc.querySelector('[data-infinite-trigger]');
        nextUrl = newTrigger ? newTrigger.dataset.nextUrl || '' : '';

        setBusy(false);
        if (!nextUrl) done();
      })
      .catch(() => {
        setBusy(false);
        if (loadMoreBtn) loadMoreBtn.hidden = false;
        if (statusEl) statusEl.textContent = window.themeStrings.loading_error;
      });
  }

  if (loadMoreBtn) loadMoreBtn.addEventListener('click', loadNext);

  if (usingObserver) {
    observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadNext();
      },
      { rootMargin: '600px 0px' }
    );
    observer.observe(trigger);
  }
}

function initAllCollectionsLists(root = document) {
  root.querySelectorAll('[data-collections-list]').forEach(initCollectionsListPagination);
}

initAllCollectionsLists();

// Theme editor: re-init when the section is re-rendered after a setting change.
document.addEventListener('shopify:section:load', (event) => {
  initAllCollectionsLists(event.target);
});
